import { useAppStore } from "@/stores/RootStore";
import { useScreenStore } from "@/stores/ScreenStore";
import { useTabsStore } from "@/stores/TabsStore";
import { Button } from "@/ui/Button";
import React from "react";
import { useNavigate } from "react-router-dom";

type Props = {
  error: any;
  resetErrorBoundary: any;
};

const ErrorFallback = ({ error, resetErrorBoundary }: Props) => {
  const store = useAppStore();
  const resetTabsStore = useTabsStore((store) => store.resetStore);
  const resetScreenStore = useScreenStore((store) => store.resetStore);
  const navigate = useNavigate();

  const signout = () => {
    if (typeof window !== "undefined") {
      resetTabsStore();
      resetScreenStore();
      resetErrorBoundary();

      localStorage.removeItem("weld-jwt");
      navigate("/");

      return fetch("/users/sessions", {
        method: "DELETE",
      })
        .then((response) => {
          store.resetStore();
        })
        .catch((err) => console.log(err));
    }
  };

  return (
    <div className="flex items-center justify-center h-screen" role="alert">
      <div className="p-4 border">
        <p>Произошла непредвиденная ошибка:</p>
        <pre style={{ color: "red" }}>{error.message}</pre>
        <div className="grid grid-cols-2 gap-4">
          <Button
            variant="outline"
            onClick={() => {
              resetErrorBoundary();
              navigate("/");
            }}
          >
            Вернуться на главную
          </Button>
          <Button
            variant="outline"
            onClick={() => {
              signout();
            }}
          >
            Сбросить данные
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorFallback;
